import { takeLatest, put, all, call } from "redux-saga/effects";
import { encryptData } from "../../_common/enode-decode";
import {
  ComonExportPage,
  fetchAverageMonthlyPerformanceReport,
} from "./averageMonthlyPerformanceReport.services";
import {
  averageMonthlyPerformanceReportFetchSuccess,
  averageMonthlyPerformanceReportFetchFailure,
  averageMonthlyPerformanceReportFetchResponseChanged,
  averageMonthlyPerformanceReportExportAllFailure,
  averageMonthlyPerformanceReportExportAllSuccess,
  averageMonthlyPerformanceReportExportAllChanged,
} from "./averageMonthlyPerformanceReport.action";
import PerforamanceReportTypes from "./averageMonthlyPerformanceReport.types";

/** *********************** START AVERAGE MONTHLY PERFORMANCE REPORT LIST ************************ */
export function* AverageMonthlyPerformanceReportListFetch({ payload }: any) {
  const key: any = "AverageMonthlyPerformanceReportKey";
  try {
    const jsonData: any = {
      LeadSourceID: payload.leadSourceID,
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      CompanyID: payload.CompanyID,
      ReportType: payload.ReportType,
      InstanceName: payload.InstanceName,
      BranchID: payload.BranchID,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(
      // @ts-ignore
      fetchAverageMonthlyPerformanceReport,
      fetchData,
    );
    if (responseData.data.statusCode === "100") {
      yield put(averageMonthlyPerformanceReportFetchFailure(responseData.data));
    } else {
      yield put(averageMonthlyPerformanceReportFetchSuccess(responseData.data));
    }
  } catch (error) {
    yield put(averageMonthlyPerformanceReportFetchFailure(error));
  }
}
export function* averageMonthlyPerformanceReportFetchReset() {
  yield put(averageMonthlyPerformanceReportFetchResponseChanged());
}
export function* onFetchListAverageMonthlyPerformanceReport() {
  yield takeLatest(
    PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_START,
    AverageMonthlyPerformanceReportListFetch,
  );
}
export function* onAverageMonthlyPerformanceReportResponseReset() {
  yield takeLatest(
    PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_FETCH_RESET_START,
    averageMonthlyPerformanceReportFetchReset,
  );
}

/** *********************** END AVERAGE MONTHLY PERFORMANCE REPORT LIST ************************ */

/** *********************** START AVERAGE MONTHLY PERFORMANCE REPORT EXPORT ************************ */
export function* averageMonthlyPerformanceReportListExport({ payload }: any) {
  const key: any = "CreateRequestReportKey";
  try {
    const jsonData: any = {
      BranchID: payload.BranchID,
      IsFresh: payload.IsFresh,
      ConditionExec: payload.ConditionExec,
      ExistRequestID: 1,
      CreateDateTime: payload.CreateDateTime,
      RequestReportPage: payload.RequestReportPage,
      CompanyID: payload.CompanyID,
      RequestedBy: payload.RequestedBy,
      URL: payload.URL,
      FromDate: payload.FromDate,
      ToDate: payload.ToDate,
      MemberID: payload.MemberID,
      DateType: payload.DateType,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(ComonExportPage, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(
        averageMonthlyPerformanceReportExportAllFailure(responseData.data),
      );
    } else {
      yield put(
        averageMonthlyPerformanceReportExportAllSuccess(responseData.data),
      );
    }
  } catch (error) {
    yield put(averageMonthlyPerformanceReportExportAllFailure(error));
  }
}
export function* averageMonthlyPerformanceReportExportAllReset() {
  yield put(averageMonthlyPerformanceReportExportAllChanged());
}
export function* onExportListAverageMonthlyPerforamanceReport() {
  yield takeLatest(
    PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_START,
    averageMonthlyPerformanceReportListExport,
  );
}
export function* onAverageMonthlyPerforamanceReportExportReset() {
  yield takeLatest(
    PerforamanceReportTypes.AVERAGE_MONTHLY_PERFORMANCE_REPORT_EXPORT_RESET_START,
    averageMonthlyPerformanceReportExportAllReset,
  );
}
/************************* END AVERAGE MONTHLY PERFORMANCE REPORT EXPORT ************************ */

export function* averageMonthlyPerformanceReportSaga() {
  yield all([
    call(onAverageMonthlyPerformanceReportResponseReset),
    call(onFetchListAverageMonthlyPerformanceReport),
    call(onExportListAverageMonthlyPerforamanceReport),
    call(onAverageMonthlyPerforamanceReportExportReset),
  ]);
}
